// components/common/TablePagination.tsx
import React from 'react';

interface TablePaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number | ((prev: number) => number)) => void;
}

export const TablePagination: React.FC<TablePaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  const startIndex = (currentPage - 1) * itemsPerPage;

  return (
    <div className="flex items-center justify-between border-t border-slate-200 bg-slate-50 px-4 py-2.5">
      <div className="text-xs text-slate-500">
        စုစုပေါင်း <span className="font-semibold text-slate-700">{totalItems}</span> ခုအနက်မှ{' '}
        <span className="font-semibold text-slate-700">{startIndex + 1}</span> မှ{' '}
        <span className="font-semibold text-slate-700">
          {Math.min(startIndex + itemsPerPage, totalItems)}
        </span>{' '}
        ပြသနေသည်။
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={currentPage === 1}
          onClick={() => onPageChange((prev) => prev - 1)}
          className="inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 bg-white text-xs text-slate-600 disabled:opacity-50 hover:bg-slate-100 transition-colors"
        >
          ◀
        </button>
        <div className="text-xs font-medium text-slate-700">
          {currentPage} / {totalPages}
        </div>
        <button
          type="button"
          disabled={currentPage === totalPages}
          onClick={() => onPageChange((prev) => prev + 1)}
          className="inline-flex h-7 w-7 items-center justify-center rounded border border-slate-200 bg-white text-xs text-slate-600 disabled:opacity-50 hover:bg-slate-100 transition-colors"
        >
          ▶
        </button>
      </div>
    </div>
  );
};